import axios from 'axios'
import Store from '@/store/index.js'

axios.defaults.withCredentials = true

axios.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'

  return config
}, err => {
  return Promise.reject(err)
})

axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          const userServerUrl = Store.state.initConfig.urlInfo.userservice
          const serverName = Store.state.initConfig.serverName
          console.log(`${userServerUrl}/?url=${location.protocol}//${location.host}&serviceName=${serverName}`)
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}&serviceName=${serverName}`
            break
      }
    }
    return Promise.reject(error)
  }
)

export default axios